'use client';
import { useTranslations } from 'next-intl';
import { useSessionGuardStore } from '@/stores/sessionGuardStore';
import { Button } from '@/components/ui/Button';

export function IdleWarningModal() {
  const t = useTranslations('sessionGuard');
  const open = useSessionGuardStore((s) => s.idleWarningOpen);
  const dismiss = useSessionGuardStore((s) => s.actions.dismissIdleWarning);
  if (!open) return null;
  return (
    <div
      role="alertdialog"
      aria-live="assertive"
      aria-modal="true"
      aria-labelledby="idle-warning-title"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-overlay backdrop-blur-sm"
    >
      <div className="rounded-lg border border-border bg-surface p-6 shadow-lg max-w-sm text-center space-y-4">
        <h2 id="idle-warning-title" className="font-serif text-lg font-medium leading-tight">
          {t('idleWarningModal.title')}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t('idleWarningModal.body')}
        </p>
        <Button onClick={dismiss} className="w-full">{t('idleWarningModal.staySignedIn')}</Button>
      </div>
    </div>
  );
}
